import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import { Footer } from './layout/Footer';
import Home from './pages/Home';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import Header from './layout/Header';
import { Knowledge } from './pages/Knowledge'
import { FAQ } from './pages/FAQ'
import Answers from './pages/Answers'
import CreateTicket from './pages/CreateTicket'
import Chat from './pages/Chatpage'
import Changelog from './pages/Changelog'
import Contact from './pages/Contact'


function App() {
  return (
    <div className="App">
      <HashRouter>
        <NotificationContainer />
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/knowledge" component={Knowledge} />
          <Route path="/faq" component={FAQ} />
          <Route path="/changelog" component={Changelog} />
          <Route path="/contact" component={Contact} />
          <Route path="/customerticket" component={CreateTicket} />
          <Route path="/answers/:answersid/:answerssubject/" component={Answers} />
          <Route path="/chatpage/:ticketid" component={Chat} />
        </Switch>
        <Footer />
      </HashRouter>
    </div>
  );
}

export default App;
